import { render, staticRenderFns } from "./HeaderMasterProduk.vue?vue&type=template&id=33969b9a&"
import script from "./HeaderMasterProduk.vue?vue&type=script&lang=js&"
export * from "./HeaderMasterProduk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports